import { Box, Typography, Link } from "@mui/material";
import { useNavigate } from "react-router";
import { useLocation } from "react-router-dom";

const GsgWidgetFooter = () => {

  const navigate = useNavigate();

  const handleLinkClick = (url) => {
    navigate(url);
  }
    const excludedKeyWords = [
        "unclaimed-refunds",
        "public-acquisition-request",
        "tax-dollar-breakdown",
    ];
    const location = useLocation();
    const bulkPaymentRender = !excludedKeyWords.some(keyword =>location.pathname.includes(keyword));
  return (
    <>


      <div><div style={{
        backgroundColor: "#f8f8f8",
          }} className="w-100">
              {bulkPaymentRender &&(
              <Typography variant="body2" sx={{ padding: 2 }}>

                  Save time by using the  <Link onClick={() => handleLinkClick("/tax-collector/bulk-tax-payments")} underline="hover" style={{ cursor: "pointer" }}>bulk add feature</Link> to pay for up to 3,000 accounts in one upload. A quick login is required.

                  </Typography>)}
      </div></div>
      <Box sx={{ textAlign: "center", padding: 2, fontSize: 14 }}>
        <Typography variant="body2">
          If you are encountering any issues with the property tax services, please{" "}
          <Link onClick={() => handleLinkClick("/contact-us?query=technical_support")} underline="hover" style={{ cursor: "pointer" }}>
            contact us here
          </Link>.
        </Typography>
      </Box></>
  );
};

export default GsgWidgetFooter;
